export default __webpack_public_path__ + "static/media/check-plain-glyph-16-px.dc694ed9.svg";